"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _streamChatReact = require("stream-chat-react");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["onSelect", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var ChatPreview = function ChatPreview(_ref) {
  var onSelect = _ref.onSelect,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var channel = props.channel;
  var channelMuted = channel.muteStatus().muted;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('chat-preview', {
      'chat-preview--muted': channelMuted
    }),
    title: channelMuted ? 'muted' : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: onSelect
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.ChannelPreviewLastMessage, props)), children);
};
var _default = ChatPreview;
exports.default = _default;